"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiTransferDto = void 0;
const billing_core_transfer_perform_mode_enum_1 = require("../../../../billing-core/billing-core-transfer/types/enums/billing-core-transfer-perform-mode.enum");
const swagger_1 = require("../../../../swagger-fake");
const class_validator_1 = require("class-validator");
class BillingApiTransferDto {}
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сумма перевода",
  type: String,
  format: "decimal",
  pattern: "^d{1,}(.d{1,6})?$",
  example: "100.00"
}), (0, class_validator_1.IsDecimal)({
  decimal_digits: "1,"
}), __metadata("design:type", String)], BillingApiTransferDto.prototype, "amount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Счёт списания`,
  format: "uuid"
}), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiTransferDto.prototype, "fromAccountId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Счёт зачисления`,
  format: "uuid"
}), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiTransferDto.prototype, "toAccountId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Нужно ли блокировать средства на счёте до исполнения трансфера`
}), (0, class_validator_1.IsBoolean)(), __metadata("design:type", Boolean)], BillingApiTransferDto.prototype, "hold", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Режим исполнения трансфера`,
  enum: billing_core_transfer_perform_mode_enum_1.BillingCoreTransferPerformModeEnum
}), (0, class_validator_1.IsEnum)(billing_core_transfer_perform_mode_enum_1.BillingCoreTransferPerformModeEnum), __metadata("design:type", String)], BillingApiTransferDto.prototype, "performMode", void 0);
exports.BillingApiTransferDto = BillingApiTransferDto;
